import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%'
    },
    firmRoot: {
        display: 'flex',
        flexDirection: 'column',
        '& .MuiTableCell-root': {
            padding: '6px 10px',
            lineHeight: 1.25
        }
    },
    tableCell: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    firmTableCell: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 220
    },
    memberChip: {
        maxWidth: 150,
        '& .MuiChip-label': {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    dangerMenuItem: {
        color: '#d32f2f'
    },
    container: {
        maxHeight: 'calc(100vh - 250px)',
        minHeight: 'calc(100vh - 250px)'
    },
    firmContainer: {
        maxHeight: 'calc(100vh - 255px)',
        minHeight: 'calc(100vh - 255px)'
    },
    footer: {
        bottom: 0,
        position: 'fixed',
        width: '100%',
        left: 0,
        right: 0,
        zIndex: 10,
        backgroundColor: '#fafafa'
    },
    firmFooter: {
        position: 'static',
        width: 'auto',
        left: 'auto',
        right: 'auto',
        zIndex: 'auto',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        backgroundColor: '#fafafa'
    }
});
export const CommonTableStyle = () => useStyles();
